export const WHITE_LABLED_APPS: String[] = ['ssvm', 'reeds', 'ssvmkidscasa'];
